import { API } from './api';
import { cacheReceipt, getPendingReceipts, markPendingReceipt, removePendingReceipt } from './offlineDb';

export async function syncPendingReceipts(token) {
  if (!token || !navigator.onLine) return { synced: 0, conflicts: 0, failed: 0 };

  const pending = await getPendingReceipts();
  const result = { synced: 0, conflicts: 0, failed: 0 };

  for (const item of pending.filter((receipt) => receipt.status !== 'syncing')) {
    await markPendingReceipt(item.id, { status: 'syncing', last_attempt_at: new Date().toISOString() });

    try {
      const res = await fetch(`${API}/receipts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify(item.payload)
      });

      if (res.status === 409 || res.status === 404 || res.status === 400 || res.status === 403) {
        await markPendingReceipt(item.id, { status: 'sync_conflict', last_error: await res.text() });
        result.conflicts += 1;
        continue;
      }

      if (!res.ok) throw new Error(await res.text());

      const data = await res.json();
      await cacheReceipt(data.receipt);
      await removePendingReceipt(item.id);
      result.synced += 1;
    } catch (error) {
      await markPendingReceipt(item.id, {
        status: 'pending_sync',
        last_error: error.message || 'Network sync failed'
      });
      result.failed += 1;
    }
  }

  window.dispatchEvent(new Event('offline-receipts-updated'));
  return result;
}
